<template>
  <div>
    <div class="card-inner">
      <div class="preview-block">
        <span class="preview-title-lg overline-title">{{ $t('comp_footer_footer') }}</span>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">{{ $t('comp_footer_company') }}</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.company" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">{{ $t('common_street') }}</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.street" type="text" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">{{ $t('common_city') }}</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.city" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6"></div>
        </div>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">{{ $t('comp_footer_phone') }}</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.phone" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">{{ $t('comp_footer_mobile') }}</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.mobile" type="text" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">{{ $t('comp_footer_email') }}</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.email"  type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">{{ $t('comp_footer_web') }}</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.web"  type="text" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <hr class="preview-hr" /> 
        <div class="form-group"> 
          <div v-if="infoSaved" class="alert alert-success alert-icon">
            <em class="icon ni ni-check-circle"></em> {{ $t('common_saved') }}
          </div>
          <button
            type="submit"
            class="btn btn-lg btn-primary"
            @click="saveForm()"
          >
            {{ $t('common_save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  saveMainReportSettings
} from "@/services/reporting.service";

export default {
  name: "ReportFooter",
  components: {
   

  },
  data() {
    return {
      infoSaved: false
    };
  },
  computed: {
    report_settings: function () {
      return this.$store.state.rp_report_settings;
    },
  },

  methods: {
    saveForm: function () {
        saveMainReportSettings(this.$store.state.rp_report_settings).then( d => {
            console.log("d", d)
        })
    }
  }

};
</script>

<style>
</style>